// var ISDIN_URL="http://www.isdin.com";

var COOKIE_DOMAIN = ".isdin.com";
// var hubURL = "https://hub.isdin.com/";
var modalPreviouslyShowed = $.cookie("popup_message_displayed");

var body = document.body || document.bodyElement,
  maxScrollPct = 0,
  timer = null,
  sendEvent = function () {
    ga(
      "send",
      "event",
      "scroll",
      "scroll_down",
      window.location.href,
      maxScrollPct
    );
  };
/* Function to print PDF*/
function printPDF(iframeToPrint, url) {
  var _this = this,
    iframeId = iframeToPrint,
    $iframe = $("iframe#" + iframeToPrint);
  $iframe.attr("src", url);

  $iframe.load(function () {
    setTimeout(_this.callPrint(iframeId), 2000);
  });
}
/* Function to disable Scroll on mobile */
function disableScroll() {
  if (isMobile() || isTabletPortrait()) {
    $("html").removeClass("enableScroll");
    $("html").addClass("disableScroll");

    $(".mobile.opened").addClass("enableScroll");
    $(".secondLevel").addClass("enableScroll");
    $("#firstLevel").addClass("enableScroll");

    $(".mobile.opened").removeClass("disableScroll");
    $(".secondLevel").removeClass("disableScroll");
    $("#firstLevel").removeClass("disableScroll");

    $(".mobile.opened").ontouchmove = function (e) {
      return true;
    };
    $(".secondLevel").ontouchmove = function (e) {
      return true;
    };
    $("#firstLevel").ontouchmove = function (e) {
      return true;
    };
  }
}

function cleanScroll() {
  $(".mobile").removeClass("disableScroll");
  $(".secondLevel").removeClass("disableScroll");
  $("#firstLevel").removeClass("disableScroll");
  $(".mobile").removeClass("enableScroll");
  $(".secondLevel").removeClass("enableScroll");
  $("#firstLevel").removeClass("enableScroll");
}

function enableScroll() {
  if (isMobile() || isTabletPortrait()) {
    $("html").addClass("enableScroll");
    $("html").removeClass("disableScroll");

    $(".mobile.opened").addClass("disableScroll");
    $(".secondLevel").addClass("disableScroll");
    $("#firstLevel").addClass("disableScroll");

    $(".mobile.opened").removeClass("enableScroll");
    $(".secondLevel").removeClass("enableScroll");
    $("#firstLevel").removeClass("enableScroll");
  }
}

function isMobile() {
  return $(window).width() < 768;
}

function isTabletLandscape() {
  return isTablet() && window.innerHeight <= window.innerWidth;
}

function isTabletPortrait() {
  return isTablet() && window.innerHeight > window.innerWidth;
}

function isTablet() {
  return $(window).width() > 767 && $(window).width() < 1025;
}

/* Function to load videos */

function loadVideo(event, element) {
  if (element.data("youtube")) {
    var url =
      "https://www.youtube.com/embed/" +
      element.data("youtube") +
      "?autoplay=1&rel=0&showinfo=0&controls=1&modestbranding=1";
    var iframe =
      '<iframe src="' +
      url +
      '" frameborder="0" allowfullscreen></iframe><a class="hero-modal-close" rel="nofollow"></a>';

    if (element.hasClass("lightbox")) {
      element.ekkoLightbox({
        remote: url,
        width: "100%",
      });
      $(".ekko-lightbox").append(
        '<a class="hero-modal-close" data-dismiss="modal" ></a>'
      );
    }

    event.preventDefault();
    event.stopPropagation();
  }
}

/* Function to adjust size of faces */
function resizeFaces() {
  var widths = [],
    heights = [],
    heightMin,
    widthMin;

  $(".imagesCircle img").each(function () {
    width = $(this).width();
    height = $(this).height();

    if (width) {
      widths.push(width);
    }

    if (height) {
      heights.push(height);
    }
  });

  widthMin = Math.min.apply(Math, widths);
  heightMin = Math.min.apply(Math, heights);
  if (widthMin !== 1) {
    $(".imagesCircle img").each(function () {
      $(this).width(widthMin);
      $(this).height(heightMin);
    });
  }
}

/* Initiates print once content has been loaded into iframe */
function callPrint(iframeId) {
  var PDF = document.getElementById(iframeId);
  PDF.focus();
  PDF.contentWindow.print();
}

/* Function to show the submenu */
function showSubmenu(object, mobile, sticky, subMenuNav) {
  cleanScroll();
  var target;
  if (mobile === true) {
    target = object.parent().data("target-mobile");
  } else {
    target = object.parent().data("target");
  }
  if (sticky) {
    if (mobile === true) {
      $(target).css("position", "absolute");
      $(target).css("top", "-21px");
    } else {
      $(target).css("position", "fixed");
      $(target).css("top", "117px");
    }

    $(target + ">li").show();
  }

  $("#subMenuNav").toggleClass("haveSubmenuAndIsVisible", subMenuNav === true);
  $(".submenu").toggleClass("haveSubmenuAndIsVisible", subMenuNav === true);

  $(".bottomBar").show();

  if (!$(target).is(":visible")) {
    //Show submenu

    $("section.mobile").css("height", "100%");
    object.removeClass("menuActive");
    $(".submenu").hide();
    $(target).addClass("showSlider");
    var top;
    if ($(window).scrollTop() < 53) {
      if (sticky) {
        top = $("div#subMenuNav").offset().top + $("div#subMenuNav").height();
      } else {
        top = 100;
      }
      $(target).css("top", top);
    } else {
      top = 61;
      if (sticky) {
        top = $("div#subMenuNav").height();
      }
      $(target).css("top", top);
    }

    $("#firstLevel").hide();
    $("#titleBack").hide();
    $(target).show();
    $(target).css("visibility", "visible");
  } else {
    //close submenu

    $("section.mobile").css("height", "0");
    $(target).css("visibility", "hidden");
    $(target).hide();
    $("#firstLevel").show();
    $("#titleBack").show();
    object.removeClass("menuActive");
    object.removeClass("menuActive");
  }

  if (mobile === true) {
    if ($("#menuMobile").is(":visible")) {
      $("#menuMobile").removeAttr("style");
      $(target).parent().removeAttr("style");
      $(target).parent().parent().css("display", "none");
    } else {
      $("#menuMobile").show();
      $(target).parent().css("visibility", "visible");
      $(target).parent().css("top", 0);
      $(target).parent().css("display", "block");
      $(target).parent().parent().css("display", "block");
    }

    if (!$(".submenuC .fa.fa-plus").is(":visible")) {
      $(".submenuC .fa.fa-plus").show();
      $(".submenuC .fa.fa-minus").hide();
    } else {
      $(".submenuC .fa.fa-plus").hide();
      $(".submenuC .fa.fa-minus").show();
    }
  } else if (sticky) {
    if ($(".submenuC .fa-chevron-down").length) {
      $(".submenuC .fa-chevron-down")
        .addClass("fa-chevron-up")
        .removeClass("fa-chevron-down");
    } else {
      $(".submenuC .fa-chevron-up")
        .addClass("fa-chevron-down")
        .removeClass("fa-chevron-up");
    }
  }

  if (!object.parent().hasClass("changeLang")) {
    $(".toggle-submenu a").removeClass("menuActive");
  }
}

var currentUrl = window.location.pathname;

var usLightbox = function (response) {
  if (response.country != "US") {
    return; //Do nothing
  } else if (!modalPreviouslyShowed) {
    $("#modal-us").modal("show");
    $("#modal-us").addClass("is-active");
  }
};

var beLightbox = function (response, hasCookie) {
  if (!hasCookie) {
    if (response.country != "BE") {
      return; //Do nothing
    } else if (!modalPreviouslyShowed) {
      $("#modal-be").modal("show");
      $("#modal-be").addClass("is-active");
    }
  }
};

var sliderAutoPlay = function () {
  $(".carousel-inner.autoplay").swipeleft();
};

var getQueryString = function () {
  // This function is anonymous, is executed immediately and
  // the return value is assigned to QueryString!
  var query_string = {};
  var query = window.location.search.substring(1);
  if (query) {
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      // If first entry with this name
      if (typeof query_string[pair[0]] === "undefined") {
        query_string[pair[0]] = pair[1];
        // If second entry with this name
      } else if (typeof query_string[pair[0]] === "string") {
        var arr = [query_string[pair[0]], pair[1]];
        query_string[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        query_string[pair[0]].push(pair[1]);
      }
    }
  }
  return query_string;
};

var getParameterByName = function (name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

var addPreloader = function (wrapper) {
  var preloader =
    '<div class="loader-wrapper"><div class="loader"></div></div>';
  wrapper.append(preloader);
};

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};
var merger = function (obj1, obj2) {
  var obj3 = {};
  for (var attrname in obj1) {
    obj3[attrname] = obj1[attrname];
  }
  for (var attrname2 in obj2) {
    obj3[attrname2] = obj2[attrname2];
  }
  return obj3;
};

var arrayObjectIndexOf = function (myArray, searchTerm, property) {
  for (var i = 0, len = myArray.length; i < len; i++) {
    if (myArray[i][property] === searchTerm) return i;
  }
  return -1;
};

window.checkNavMenu = function () {
  const filiate = $("html").attr("urlFiliate");
  const modalFiliates = ["es-CL"];
  if (modalFiliates.includes(filiate)) {
    $("#loveIsdinModalMov").length && $("#loveIsdinModalMov").appendTo("body");
    $(".loveisdinmodal").length && $(".loveisdinmodal").removeClass("hddn");
    // $('.loveisdin').length && $('.loveisdin').removeClass('hddn');
    $(".love").length && $(".love").addClass("hddn");
  }

  const noLoveIsdin = ["en-SG"];
  if (noLoveIsdin.includes(filiate)) {
    $(".love").length && $(".love").addClass("hddn");
  }
};

$(document).ready(function () {
  window.checkNavMenu();

  $("section img.lazy").lazyload({
    threshold: 200,
  });
  $(".submenu img.lazy").lazyload({
    skip_invisible: true,
    event: "loadLazyImg",
  });

  $(".player").mb_YTPlayer();

  /*// TODO: Ticket 635
  setTimeout(function(){
    resizeFaces();
  },500);*/

  //Itraisdin
  $(".elementSubMenu").each(function (index, value) {
    var url = $(this).children("a").attr("href");
    if (currentUrl == url) {
      $(this).addClass("active");
    }
  });

  /*Isdinceutics slider fotos before and after*/
  $(".before-after").twentytwenty({
    default_offset_pct: 0.6,
  });
  var style;
  if ($(".before-after").length) {
    style = '<style type="text/css">';
    style += " .before-after .twentytwenty-before-label:before { ";
    style +=
      'content: "' +
      $(".before-after .before").data("textbefore") +
      '" !important;}';
    style += " .before-after .twentytwenty-after-label:before { ";
    style +=
      'content: "' +
      $(".before-after .after").data("textafter") +
      '" !important;}';
    style += "</style>";
    $("head").append(style);
  }

  $(".before-after-inverse").twentytwenty({
    default_offset_pct: 0.6,
  });
  if ($(".before-after-inverse").length) {
    style = '<style type="text/css">';
    style += " .before-after-inverse .twentytwenty-after-label:before { ";
    style +=
      'content: "' +
      $(".before-after-inverse .after").data("textafter") +
      '" !important;}';
    style += " .before-after-inverse .twentytwenty-before-label:before { ";
    style +=
      'content: "' +
      $(".before-after-inverse .before").data("textbefore") +
      '" !important;}';
    style += "</style>";
    $("head").append(style);
  }
  /**/

  function setLangModals(response) {
    var hasCookie = $.cookie("geoip_isdin_country");
    usLightbox(response);
    beLightbox(response, hasCookie);
    jQuery.cookie("geoip_isdin_country", response.country, {
      path: "/",
      domain: COOKIE_DOMAIN,
    });
  }
  /*End of cookies*/
  if ($("html").attr("urlfiliate") !== "https://www.nutraseb.com/") {
    //US Lightbox logic
    var country = $.cookie("geoip_isdin_country");

    if (country === undefined || country === null) {
      $.ajax({
        method: "GET",
        url: "//geoip.isdin.com",
        dataType: "json",
        success: setLangModals,
        error: function (response) {
          console.log(response);
        },
      });
    } else {
      setLangModals({
        country: country,
      });
    }
  }

  $("form.webservice-isdin-medic").each(function (e) {
    var form = $(this);
    var url = window.location.href;

    ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach(
      function (param) {
        var paramValue = getParameterByName(param, url);
        if (paramValue !== null && paramValue !== "") {
          $("<input>")
            .attr({
              type: "hidden",
              value: paramValue,
              name: param,
            })
            .appendTo(form);
        }
      }
    );
  });

  $("form.webservice-isdin-medic").submit(function (e) {
    var errorLegal = $('input[name="legal"]').length ? undefined : true;
    $(".resultForm").html("");
    var jsonObj = [];

    var locale = $("html").attr("urlFiliate");
    if (locale) {
      locale = locale + "/";
    }

    e.preventDefault();
    var inputs = $(this).find(":input");
    var errorMandatory = false;
    var form = $(this);
    var entryInput = true;
    errorLegal = true;
    inputs.each(function (index, value) {
      entryInput = true;

      if (
        value.type == "text" &&
        !value.value &&
        !$(this).hasClass("optional") &&
        value.name != "salesforce_client_code"
      ) {
        errorMandatory = true;
      }
      if (
        value.type == "number" &&
        !value.value &&
        !$(this).hasClass("optional")
      ) {
        errorMandatory = true;
      }

      if (value.name == "legal" && $(this).prop("checked")) {
        errorLegal = false;
        value.value = true;
      }

      if (
        value.type == "radio" &&
        (!$(this).prop("checked") ||
          !$(this).closest("label").hasClass("checked"))
      ) {
        entryInput = false;
      }

      if (entryInput) {
        elem = {};
        elem.name = value.name;
        elem.value = value.value;
        jsonObj.push(elem);
      }
    });

    if (errorMandatory === true) {
      $(".resultForm")
        .html("")
        .append("<span class='ko'>" + $("#form-fill-data").html() + "</span>");
    } else if (errorLegal === true) {
      $(".resultForm")
        .html("")
        .append(
          "<span class='ko'>" + $("#form-legal-warning").html() + "</span>"
        );
    } else {
      $(".resultForm").removeClass("active");
      var posting = $.post("//www.isdin.com/" + locale + "hugo/forms", jsonObj);

      posting.done(function (data) {
        if (data.code == "ERROR") {
          $(".resultForm")
            .html("")
            .append("<span class='ko'>" + data.msg + "</span>");
        } else {
          form.find('input:not(":checkbox, :radio, :hidden, :submit")').val("");
          form
            .find("input[type=checkbox], input[type=radio]")
            .prop("checked", false)
            .trigger("formikation.update");
          jQuery.cookie("nameLoveIsdin", $("#firstName").val(), {
            path: "/",
            domain: COOKIE_DOMAIN,
          });
          form.find('input:not(":checkbox, :radio, :hidden, :submit")').val("");
          form
            .find("input[type=checkbox], input[type=radio]")
            .prop("checked", false)
            .trigger("formikation.update");
          if (form.attr("id") === "love-isdin-med") {
            window.location.replace("/loveisdin-med-thanks/");
          } else {
            window.location.replace("/icnbarcelona2017-thanks/");
          }
          //$(".resultForm").html("").append("<span class='ok'>" + $("#form-success").html() + "</span>");
        }
      });

      posting.fail(function () {
        $(".resultForm")
          .html("")
          .append(
            "<span class='ko'>" + $("#form-something-wrong").html() + "</span>"
          );
      });
    }
  });

  $("form.webservice").each(function (e) {
    var form = $(this);
    var url = window.location.href;

    ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach(
      function (param) {
        var paramValue = getParameterByName(param, url);
        if (paramValue !== null && paramValue !== "") {
          $("<input>")
            .attr({
              type: "hidden",
              value: paramValue,
              name: param,
            })
            .appendTo(form);
        }
      }
    );
  });

  $("form.webservice").submit(function (e) {
    var errorLegal = $('input[name="legal"]').length ? undefined : true;
    $(".resultForm").html("");
    var jsonObj = [];
    var form = $(this);
    var locale = $("html").attr("urlFiliate");
    if (locale) {
      locale = locale + "/";
    }

    e.preventDefault();
    var inputs = $(this).find(":input");
    var errorMandatory = false;
    var entryInput = true;
    var existsRadio = false;
    var radioChecked = false;
    inputs.each(function (index, value) {
      entryInput = true;

      if (
        value.name == "form_id" &&
        value.value == "campaign_fotoproteccion_newsletter"
      ) {
        errorLegal = "true";
      }

      if (value.type == "text" && !value.value) {
        errorMandatory = true;
      }

      if (value.name == "legal" && $(this).prop("checked")) {
        errorLegal = true;
        value.value = true;
      }
      if (value.name == "newsletter") {
        if ($(this).prop("checked")) {
          value.value = true;
        } else {
          value.value = false;
        }
      }

      if (value.type == "radio") {
        existsRadio = true;
        if (
          $(this).prop("checked") ||
          $(this).closest("label").hasClass("checked")
        ) {
          radioChecked = true;
        } else {
          entryInput = false;
        }
      }

      if (entryInput) {
        elem = {};
        elem.name = value.name;
        elem.value = value.value;
        jsonObj.push(elem);
      }
    });

    if (errorMandatory === true) {
      $(".resultForm")
        .html("")
        .append("<span class='ko'>" + $("#form-fill-data").html() + "</span>");
    } else if (existsRadio === true && radioChecked === false) {
      $(".resultForm")
        .html("")
        .append("<span class='ko'>" + $("#form-fill-data").html() + "</span>");
    } else if (errorLegal === undefined) {
      $(".resultForm")
        .html("")
        .append(
          "<span class='ko'>" + $("#form-legal-warning").html() + "</span>"
        );
    } else {
      $(".resultForm").removeClass("active");
      var posting = $.post("//www.isdin.com/" + locale + "hugo/forms", jsonObj);
      posting.done(function (data) {
        if (data.code == "ERROR") {
          $(".resultForm")
            .html("")
            .append("<span class='ko'>" + data.msg + "</span>");
        } else {
          form.find('input:not(":checkbox, :radio, :hidden, :submit")').val("");
          form
            .find("input[type=checkbox], input[type=radio]")
            .prop("checked", false)
            .trigger("formikation.update");
          $(".resultForm")
            .html("")
            .append(
              "<span class='ok'>" + $("#form-success").html() + "</span>"
            );
          if (form.attr("data-gtm-category")) {
            var $url = window.location.href,
              isHidden = true,
              dataCategory = "Envio formulario: " + form.data("gtm-category"),
              dataID = form.attr("id");
            trackOutboundLink($url, isHidden, dataCategory, dataID);
          }
        }
      });

      posting.fail(function () {
        $(".resultForm")
          .html("")
          .append(
            "<span class='ko'>" + $("#form-something-wrong").html() + "</span>"
          );
      });
    }
  });

  $("form.webserviceNoLocale").submit(function (e) {
    var errorLegal = $('input[name="legal"]').length ? undefined : true;
    $(".resultForm").html("");
    var jsonObj = [];
    var form = $(this);

    e.preventDefault();
    var inputs = $(this).find(":input");
    var errorMandatory = false;
    var entryInput = true;
    var existsRadio = false;
    var radioChecked = false;
    inputs.each(function (index, value) {
      entryInput = true;

      if (
        value.name == "form_id" &&
        value.value == "campaign_fotoproteccion_newsletter"
      ) {
        errorLegal = "true";
      }

      if (value.type == "text" && !value.value) {
        errorMandatory = true;
      }

      if (value.name == "legal" && $(this).prop("checked")) {
        errorLegal = true;
        value.value = true;
      }
      if (value.name == "newsletter") {
        if ($(this).prop("checked")) {
          value.value = true;
        } else {
          value.value = false;
        }
      }

      if (value.type == "radio") {
        existsRadio = true;
        if (
          $(this).prop("checked") ||
          $(this).closest("label").hasClass("checked")
        ) {
          radioChecked = true;
        } else {
          entryInput = false;
        }
      }

      if (entryInput) {
        elem = {};
        elem.name = value.name;
        elem.value = value.value;
        jsonObj.push(elem);
      }
    });

    if (errorMandatory === true) {
      $(".resultForm")
        .html("")
        .append("<span class='ko'>" + $("#form-fill-data").html() + "</span>");
    } else if (existsRadio === true && radioChecked === false) {
      $(".resultForm")
        .html("")
        .append("<span class='ko'>" + $("#form-fill-data").html() + "</span>");
    } else if (errorLegal === undefined) {
      $(".resultForm")
        .html("")
        .append(
          "<span class='ko'>" + $("#form-legal-warning").html() + "</span>"
        );
    } else {
      $(".resultForm").removeClass("active");
      var posting = $.post("//www.isdin.com/hugo/forms", jsonObj);
      posting.done(function (data) {
        if (data.code == "ERROR") {
          var msg =
            data.msg === undefined || data.msg === null ? "Error" : data.msg;
          $(".resultForm")
            .html("")
            .append("<span class='ko'>" + msg + "</span>");
        } else {
          form.find('input:not(":checkbox, :radio, :hidden, :submit")').val("");
          form
            .find("input[type=checkbox], input[type=radio]")
            .prop("checked", false)
            .trigger("formikation.update");
          $(".resultForm")
            .html("")
            .append(
              "<span class='ok'>" + $("#form-success").html() + "</span>"
            );
          if (form.attr("data-gtm-category")) {
            var $url = window.location.href,
              isHidden = true,
              dataCategory = "Envio formulario: " + form.data("gtm-category"),
              dataID = form.attr("id");
            trackOutboundLink($url, isHidden, dataCategory, dataID);
          }
        }
      });

      posting.fail(function () {
        $(".resultForm")
          .html("")
          .append(
            "<span class='ko'>" + $("#form-something-wrong").html() + "</span>"
          );
      });
    }
  });

  $("form.webservice-footer").each(function (e) {
    var form = $(this);
    var url = window.location.href;

    ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach(
      function (param) {
        var paramValue = getParameterByName(param, url);
        if (paramValue !== null && paramValue !== "") {
          $("<input>")
            .attr({
              type: "hidden",
              value: paramValue,
              name: param,
            })
            .appendTo(form);
        }
      }
    );
  });

  $("form.webservice-footer").submit(function (e) {
    e.preventDefault();
    var errorLegal = $('input[name="legal"]').length ? undefined : true;
    var form = $(this);
    $(".resultForm-footer").html("");
    var jsonObj = [];

    var locale = $("html").attr("urlFiliate");
    if (locale) {
      locale = locale + "/";
    }

    var inputs = $(this).find(":input");
    var errorMandatory = false;
    inputs.each(function (index, value) {
      if (
        value.name == "form_id" &&
        value.value == "campaign_fotoproteccion_newsletter"
      ) {
        errorLegal = "true";
      }

      if (value.type == "text" && !value.value) {
        errorMandatory = true;
      }

      if (value.name == "legal" && $(this).prop("checked")) {
        errorLegal = true;
        value.value = true;
      }

      if (value.name == "newsletter") {
        if ($(this).prop("checked")) {
          value.value = true;
        } else {
          value.value = false;
        }
      }

      elem = {};
      elem.name = value.name;
      elem.value = value.value;
      jsonObj.push(elem);
    });

    var buttonString = $("#footer-cookies-bottom").html();
    if (errorMandatory === true) {
      $(".resultForm-footer")
        .html("")
        .append("<span class='ko'>" + $("#form-fill-data").html() + "</span>");
    } else if (errorLegal === undefined) {
      $(".resultForm-footer")
        .html("")
        .append(
          "<span class='ko'>" + $("#form-legal-warning").html() + "</span>"
        );
    } else {
      var posting = $.post("//www.isdin.com/" + locale + "hugo/forms", jsonObj);

      posting.done(function (data) {
        if (data.code == "ERROR") {
          $(".resultForm-footer")
            .html("")
            .append("<span class='ko'>" + data.msg + "</span>");
        } else {
          form.find('input:not(":checkbox, :radio, :hidden, :submit")').val("");
          form
            .find("input[type=checkbox], input[type=radio]")
            .prop("checked", false)
            .trigger("formikation.update");
          $(".resultForm-footer")
            .html("")
            .append(
              "<span class='ok'>" + $("#form-success").html() + "</span>"
            );
        }
      });

      posting.fail(function () {
        $(".resultForm-footer")
          .html("")
          .append(
            "<span class='ko'>" + $("#form-something-wrong").html() + "</span>"
          );
      });
    }
  });

  $("form.webservice-acniben").each(function (e) {
    var form = $(this);
    var url = window.location.href;

    ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach(
      function (param) {
        var paramValue = getParameterByName(param, url);
        if (paramValue !== null && paramValue !== "") {
          $("<input>")
            .attr({
              type: "hidden",
              value: paramValue,
              name: param,
            })
            .appendTo(form);
        }
      }
    );
  });

  $("form.webservice-acniben").submit(function (e) {
    var errorLegal = false;
    var errorLegalSorteo = false;
    var $element = $(this);
    $(".resultForm").removeClass("active").html("");
    var jsonObj = [];

    e.preventDefault();
    var inputs = $(this).find(":input");
    var errorMandatory = false;
    var genderChecked = false;
    inputs.each(function (index, value) {
      if (
        (value.type == "text" && !value.value) ||
        (value.type == "number" && !value.value) ||
        (value.type == "email" && !value.value) ||
        (value.name == "concert" && value[value.selectedIndex].value == "1") ||
        (value.type == "select-one" && value[value.selectedIndex].value == "1")
      ) {
        errorMandatory = true;
      }
      if (value.type == "radio" && value.checked) {
        genderChecked = true;
      }
      if (value.type == "checkbox" && value.name == "legal" && !value.checked) {
        errorLegal = true;
      }
      if (
        value.type == "checkbox" &&
        value.name == "legalSorteo" &&
        !value.checked
      ) {
        errorLegalSorteo = true;
      }
      if (value.name == "newsletter") {
        if ($(this).prop("checked")) {
          value.value = true;
        } else {
          value.value = false;
        }
      }

      if (
        (value.type != "radio" && value.type != "submit") ||
        (value.type == "radio" && value.checked)
      ) {
        elem = {};
        elem.name = value.name;
        elem.value = value.value;
        jsonObj.push(elem);
      }
    });

    if (errorMandatory === true || genderChecked === false) {
      $(".resultForm")
        .html("")
        .append("<span class='ko'>" + $("#form-fill-data").html() + "</span>");
    } else if (errorLegal === true) {
      $(".resultForm")
        .html("")
        .append(
          "<span class='ko'>" + $("#form-legal-warning").html() + "</span>"
        );
    } else if (errorLegalSorteo === true) {
      $(".resultForm")
        .html("")
        .append(
          "<span class='ko'>" + $("#form-raffle-warning").html() + "</span>"
        );
    } else {
      var posting = $.post("//www.isdin.com/hugo/forms", jsonObj);

      posting.done(function (data) {
        if (data.code == "ERROR") {
          $(".resultForm")
            .addClass("active")
            .html("")
            .append("<span class='ko'>" + data.msg + "</span>");
        } else {
          var $url = window.location.href,
            isHidden = true,
            dataCategory = "Envio formulario: " + $element.data("gtm-category"),
            dataID = $element.attr("id");
          trackOutboundLink($url, isHidden, dataCategory, dataID);
          $(".resultForm")
            .html("")
            .append(
              "<span class='ok'>" + $("#form-success").html() + "</span>"
            );
        }
      });

      posting.fail(function () {
        $(".resultForm")
          .html("")
          .append(
            "<span class='ko'>" + $("#form-something-wrong").html() + "</span>"
          );
      });
    }
  });

  /*$(window).on('resize orientationchange', function () {
      resizeFaces();
  });*/

  var timeId = window.setInterval(sliderAutoPlay, 6000);

  $(".carousel-inner.autoplay").on("mouseover", function () {
    clearInterval(timeId);
  });

  $(".carousel-inner.autoplay").on("mouseout", function () {
    clearInterval(timeId);
    timeId = window.setInterval(sliderAutoPlay, 6000);
  });

  $('a[href*="#"]:not([href="#"]).moveSmoothly').click(function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );
        return false;
      }
    }
  });
  $("form.formikation")
    .find(
      "select:not(.no-formikation), input:file, input:checkbox, input:radio"
    )
    .formikation();

  if ($("#birthyear").length) {
    //Compruebo que el usario sea mayor de 14 años
    $("#birthyear").datepicker({
      dateFormat: "yy-mm-dd",
      minDate: new Date(1900, 1 - 1, 1),
      maxDate: "-14Y",
      defaultDate: new Date(1970, 1 - 1, 1),
      changeMonth: true,
      changeYear: true,
      yearRange: "-110:-14",
    });
  }
  if ($("#birthdate").length) {
    $("#birthdate").datepicker({
      dateFormat: "yy-mm-dd",
      minDate: new Date(1900, 1 - 1, 1),
      maxDate: "-0Y",
      defaultDate: new Date(1970, 1 - 1, 1),
      changeMonth: true,
      changeYear: true,
      yearRange: "-110:-0",
    });
  }
  if ($("#birthProfessionlYear").length) {
    $("#birthProfessionlYear").datepicker({
      dateFormat: "dd/mm/yy",
      monthsShort: [
        "Gen",
        "Feb",
        "Mar",
        "Apr",
        "Mag",
        "Giu",
        "Lug",
        "Ago",
        "Set",
        "Ott",
        "Nov",
        "Dic",
      ],
      minDate: new Date(1900, 1 - 1, 1),
      defaultDate: new Date(1970, 1 - 1, 1),
      changeDay: true,
      changeMonth: true,
      changeYear: true,
      yearRange: "1922:2020",
    });
  }
  if ($("#professionalYear").length) {
    $("#professionalYear").datepicker({
      dateFormat: "dd/mm/yy",
      monthsShort: [
        "Gen",
        "Feb",
        "Mar",
        "Apr",
        "Mag",
        "Giu",
        "Lug",
        "Ago",
        "Set",
        "Ott",
        "Nov",
        "Dic",
      ],
      minDate: new Date(1900, 1 - 1, 1),
      defaultDate: new Date(1970, 1 - 1, 1),
      changeDay: true,
      changeMonth: true,
      changeYear: true,
      yearRange: "1922:2020",
    });
  }
  $(function () {
    $("#birthProfessionlYear").datepicker();
    $("#professionalYear").datepicker();
  });

  $(window).trigger("scroll");
});

$(window).load(function () {
  var match,
    pl = /\+/g, // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = function (s) {
      return decodeURIComponent(s.replace(pl, " "));
    },
    query = window.location.search.substring(1);

  var urlParams = {};
  match = search.exec(query);
  if (match) {
    urlParams[decode(match[1])] = decode(match[2]);
  }

  if (urlParams.anchor) {
    $(window).scrollTop($(".".concat(urlParams.anchor)).offset().top - 250);
  }
  var lazyTimeout = setTimeout(function () {
    $("img.lazy").trigger("loadLazyImg");
  }, 500);
});

var menu3levelHeight = ""; // Use it to get height of menu 3 level
$(window).bind("scroll", function () {
  if ($(".submenu").is(":visible")) {
    $(".submenu").hide();
    if ($(".submenuC .fa-chevron-down").length) {
      $(".submenuC .fa-chevron-down")
        .addClass("fa-chevron-up")
        .removeClass("fa-chevron-down");
    } else {
      $(".submenuC .fa-chevron-up")
        .addClass("fa-chevron-down")
        .removeClass("fa-chevron-up");
    }
  }

  // Hide second menua
  if (!$(".mobile").hasClass("opened")) {
    $(".secondLevel").hide();
    $("section.mobile").css("height", "0");
    $(".submenuC .fa-minus").hide();
    $(".submenuC .fa-plus").show();
  }
  var scrollH;
  if (isMobile()) {
    if ($("#subMenuNav").is(":visible")) {
      scrollH = 120;
    } else {
      scrollH = 52;
    }
  } else if (isTablet()) {
    if ($("#subMenuNav").is(":visible")) {
      scrollH = 110;
    } else {
      scrollH = 50;
    }
  } else {
    if ($("#subMenuNav").is(":visible")) {
      scrollH = 150;
    } else {
      scrollH = 42;
    }
    // TODO: Revisar scroll por todo el site
  }
  if (!$("#submenu-level-3")[0]) {
    // If not exist level 3 menu
    if ($(window).scrollTop() >= scrollH) {
      if ($(".fixedSubMenu").is(":visible")) {
        if ($("#menuMobile").hasClass("opened")) {
          $(".navbar-toggle").trigger("click");
        } else {
          $("#menuMobile").removeAttr("style");
        }
      }

      if (!$(".subMenuNav").is(":visible")) {
        $(".navbar.navbar-default.main-menu").addClass("fixedSubMenu");
        $("#navTop").hide();
      }

      $(".background.bottom").addClass("fixedSubMenu");
      $(".submenu").addClass("fixedSubMenu");

      if (isTablet()) {
        if ($("#subMenuNav").is(":visible")) {
          $("body").css("padding-top", 167);
        } else {
          $("body").css("padding-top", 103);
        }
      } else {
        if (isMobile()) {
          if ($("#subMenuNav").is(":visible")) {
            // 127 is the height with padding of background.bottom
            $("body").css("padding-top", 77);
          } else {
            // 127 is the height with padding of background.bottom
            $("body").css("padding-top", 56);
          }
        } else {
          if ($("#subMenuNav").is(":visible")) {
            $("body").css("padding-top", 155);
          } else {
            $("body").css("padding-top", 110);
          }
        }
      }
    } else {
      $(".background.bottom").removeClass("fixedSubMenu");
      $(".submenu").removeClass("fixedSubMenu");

      if ($("#subMenuNav").is(":visible")) {
        $(".navbar.navbar-default.main-menu").removeClass("fixedSubMenu");
      }

      if (!isMobile()) {
        $(".navbar.navbar-default.main-menu").removeClass("fixedSubMenu");
        $("#navTop").show();
        $("body").css("padding-top", 0);
      } else {
        $(".navbar.navbar-default.main-menu").removeClass("fixedSubMenu");
        $("body").css("padding-top", 0);
      }
    }
  } else {
    // If exist menu 3 level
    if (menu3levelHeight === "") {
      menu3levelHeight =
        $("#submenu-level-3").offset().top - $("#submenu-level-3").height();
    }
    if (window.pageYOffset > menu3levelHeight) {
      $("#submenu-level-3").addClass("fixedSubMenu");
    }

    if (window.pageYOffset < menu3levelHeight) {
      $("#submenu-level-3").removeClass("fixedSubMenu");
    }
  }
});

// <!-- Lightbox implementation -->
$(document).delegate('*[data-toggle="lightbox"]', "click", function (event) {
  event.preventDefault();
  $(this).ekkoLightbox();
});

// Normalize Carousel Heights - pass in Bootstrap Carousel items.
$.fn.carouselHeights = function () {
  var carousel = $(this),
    items = $(this).children("div.item"), //grab all slides
    heights = [], //create empty array to store height values
    tallest; //create variable to make note of the tallest slide

  var normalizeHeights = function () {
    items.each(function () {
      //add heights to array
      heights.push($(this).height());
    });
    tallest = Math.max.apply(null, heights); //cache largest value
    if (tallest && tallest > 0) {
      carousel.css("min-height", tallest + "px");
    }
  };

  normalizeHeights();

  $(window).on("resize orientationchange", function () {
    //reset vars
    tallest = 0;
    heights.length = 0;

    items.each(function () {
      $(this).css("min-height", "0"); //reset min-height
    });
    normalizeHeights(); //run it again
  });
};

// Normalize blocks heights - pass in Bootstrap Carousel items.
$.fn.blockHeights = function () {
  var carousel = $(this),
    items = $(this).find("div.hideMobile div.sameHeight"), //grab all slides
    heights = [], //create empty array to store height values
    tallest; //create variable to make note of the tallest slide

  var normalizeHeights = function () {
    items.each(function () {
      //add heights to array
      heights.push($(this).height());
    });
    tallest = Math.max.apply(null, heights); //cache largest value
    // FIXME No se obtiene correctamente la altura de los bloques
    if (isTablet()) {
      tallest = tallest + 20;
    }
    if (tallest && tallest > 0) {
      items.each(function () {
        //add heights to array
        $(this).css("min-height", tallest + "px");
      });
    }
  };

  normalizeHeights();

  $(window).on("resize orientationchange", function () {
    //reset vars
    tallest = 0;
    heights.length = 0;

    items.each(function () {
      $(this).css("min-height", "0"); //reset min-height
    });
    normalizeHeights(); //run it again
  });
};

// Sliders autoplay

$("img.image:last").load(function () {
  $(".spaceBetweenColumns").blockHeights();
});

/* Eventos */
$(document)
  .on("click", ".sendForm", function (event) {
    event.preventDefault();
    /* Icon search top nav */
    var $element = $(this);
    $element.closest("form").submit();
  })
  .on("click", ".noAccept", function (event) {
    /* Close modal */
    // event.preventDefault();
    var $element = $(this);
    window.history.go(-1);
    return false;
  })
  .on("click", ".ss_block", function (event) {
    event.preventDefault();
    var $element = $(this),
      url = $(this).children("a").attr("href");
    window.open(url);
  })
  .on("click", "#backMenu", function (event) {
    //* Title button back menu mobile *//
    event.preventDefault();
    var $element = $(this),
      $titleBack = $("#titleBack"),
      parentId = $(this).attr("data-parent"),
      hideId = $(this).attr("data-hide");
    $titleBack.hide();
    if (parentId == "#firstLevel") {
      $titleBack.hide();
      $(hideId).hide();
    } else {
      $(parentId).hide();
      $(parentId + ">li").show();
      $titleBack.show();
      $("#titleBack > li > a span")
        .html("")
        .append(
          $(document)
            .find("[data-target='" + parentId + "']")
            .data("title")
        );
      $(hideId).parent().hide();
    }

    $(hideId).hide();
    $(parentId).effect(
      "slide",
      {
        direction: "left",
        mode: "show",
      },
      400
    );

    $element.attr("data-hide", parentId);
    var newParent = $(parentId).parents("ul").attr("id");
    if (!newParent) {
      newParent = "firstLevel";
    }
    $element.attr("data-parent", "#" + newParent);
  })
  .on("click", ".mobile .mobile-element a", function (event) {
    /* Links mobile menu */
    event.preventDefault();
    var $element = $(this),
      parentId = $element.parents("ul").attr("id"),
      newElementId = $element.parent().data("target");
    $("#titleBack").show();
    if (parentId == "firstLevel") {
      $("#" + parentId).hide();
    } else {
      $("#" + parentId + ">li").hide();
      $(newElementId).find("[data-show='false']").hide();
      $(newElementId).parent().show();
      $(newElementId).css("position", "initial");
      $(newElementId).css("visibility", "visible");
    }
    $("#backMenu").attr("data-parent", "#" + parentId);
    $("#backMenu").attr("data-hide", newElementId);

    $(newElementId).effect(
      "slide",
      {
        direction: "right",
        mode: "show",
      },
      400
    );
    var height = $(newElementId).children("li").length * 51;
    if (height > $(window).height()) {
      height = height + 59;
    }
    $(newElementId).css("height", height);

    $("#titleBack>li>a span").html("").append($(this).parent().data("title"));
  })
  .on("click", ".main-menu .navbar-toggle", function (event) {
    /* Show and hide elements when click in RWD button menu */
    event.preventDefault();
    var $element = $(this),
      target = $element.data("menu");
    $(target).toggleClass("opened");
    $(target).parents("section.mobile").toggleClass("opened");
    $element.toggleClass("collapsed");

    if (!$(target).hasClass("opened")) {
      //Close main menu
      $(".mobile.opened").removeAttr("style");
      $(".secondLevel.showSlider").css("visibility", "hidden");
      $(".secondLevel li").show();
      $("#subMenuNav").show("fast");
      $(target).parents("section.mobile").css("height", 0);
      $("#menuMobile").hide();
      enableScroll();
    } else {
      //open main menu
      $(".secondLevel .submenuGroup").removeAttr("style");
      $(".secondLevel").css("display", "none");
      $("#menuMobile").show();
      $(target).parents("section.mobile").css("height", "100%");
      $("#firstLevel").show();
      $("#subMenuNav").hide("fast");
      $(".secondLevel").hide();
      $("#titleBack").hide();
      $(".secondLevel").css("top", "50px");
      $(".submenuC .fa.fa-plus").show();
      $(".submenuC .fa.fa-minus").hide();
      $(".secondLevel.showSlider").css("visibility", "visible");
      disableScroll();
    }
  })
  .on("click", ".showLang", function (event) {
    event.preventDefault();
    var $element = $(this),
      target = $(this).data("target");
    $(".submenu")
      .not("#" + target)
      .hide();
    $(".bottomBar").hide();
    $(this).toggleClass("dropup");
    var $url = window.location.href,
      isHidden = true,
      dataCategory = $element.data("gtm-category"),
      lang = $element.find(".changeLang").text();
    if ($("#" + target).is(":visible")) {
      $("#" + target).hide();
      $("#" + target).removeClass("itemClicked");
      dataID = "retract-" + lang;
    } else {
      $("#" + target).addClass("itemClicked");
      $("#" + target).show();
      dataID = "dropdown-" + lang;
    }
    if (typeof trackOutboundLink === "function")
      trackOutboundLink($url, isHidden, dataCategory, dataID);
  })
  .on("click", ".submenuC", function (event) {
    /* Show and hide menu when click in sticky*/
    event.preventDefault();
    var $element = $(this);
    if (isMobile() || isTabletPortrait()) {
      showSubmenu($(this), true, true);
    } else {
      showSubmenu($(this), false, true, true);
    }
  })
  .on(
    "click",
    ".main-menu .navbar-collapse .toggle-submenu>a",
    function (event) {
      /* Show submenu in tablet click */
      var $element = $(this);
      if ($(window).width() < 1025) {
        event.preventDefault();
        showSubmenu($(this), false, false);
      }
    }
  )
  .on("mouseover", ".main-menu .navbar-collapse .hideMenu", function (event) {
    /* Show submenu in mouseover desktop */
    event.preventDefault();
    var $element = $(this);
    $(".submenu").hide();
  })
  .on(
    "mouseover",
    ".main-menu .navbar-collapse .toggle-submenu > a",
    function (event) {
      event.preventDefault();
      var $element = $(this);
      if (window.matchMedia("(min-width: 991px)").matches) {
        showSubmenu($(this), false, false);
      }
    }
  )
  .on("mouseleave", ".submenu", function (event) {
    event.preventDefault();
    /* Close submenu when leave the submenu when fired in over */

    $(".submenu").hide();

    // girem la fletxa del submenu sticky
    if ($(".submenuC .fa-chevron-up").length) {
      $(".submenuC .fa-chevron-up")
        .addClass("fa-chevron-down")
        .removeClass("fa-chevron-up");
    }
    // var $element = $(this);
    // if(!$(this).hasClass("itemClicked") && window.matchMedia("(min-width: 991px)").matches) {
    //     $(this).hide();
    // }
  })
  .on("mouseover", "#navTop", function (event) {
    $(".submenu").hide();
  })
  .on("click", "#modal-us-yes", function (event) {
    event.preventDefault();
    var $element = $(this),
      timestamp = +new Date();
    jQuery.cookie("popup_message_displayed", timestamp, {
      path: "/",
      domain: COOKIE_DOMAIN,
    });
    jQuery.cookie("multilink_pl", "en-US", {
      path: "/",
      domain: COOKIE_DOMAIN,
    });

    window.location = ISDIN_URL + "us/";
  })
  .on("click", "#modal-us-no", function (event) {
    event.preventDefault();
    var $element = $(this),
      timestamp = +new Date();
    jQuery.cookie("popup_message_displayed", timestamp, {
      path: "/",
      domain: COOKIE_DOMAIN,
    });
    jQuery.cookie("multilink_pl", "corp", { path: "/", domain: COOKIE_DOMAIN });
    $("#modal-us").modal("hide");
  })
  .on("click", "img.lightbox", function (event) {
    var $element = $(this);
    loadVideo(event, $element);
  })
  .on("click", "a.hero-modal-close", function (event) {
    $(this).parent().parent().find(".content").show();
    if ((isTablet() && isTabletPortrait()) || isMobile()) {
      $(this).parent().parent().find("img.hideDesktopBanner").show();
    } else {
      $(this).parent().parent().find(".image").show();
      $(this).parent().parent().find("img").show();
    }
    $(this).parent().html("").hide();
    event.preventDefault();
    event.stopPropagation();
  })
  .on("click", "a.youtube", function (event) {
    event.preventDefault();
    event.stopPropagation();
    var $element = $(this);
    loadVideo(event, $element);
  })
  .on("click", ".showMore", function (event) {
    event.preventDefault();
    var $element = $(this);
    var elementShow =
      $(this).data("target") === undefined
        ? $(this).find("a").data("target")
        : $(this).data("target");
    if ($("#" + elementShow).is(":visible")) {
      $("#" + elementShow).hide();
      $(this).find("i.fa-sort-asc").hide();
      $(this).find("i.fa-sort-desc").show();
    } else {
      $("#" + elementShow).show();
      $(this).find("i.fa-sort-asc").show();
      $(this).find("i.fa-sort-desc").hide();
    }
  })
  .on("click", ".js-fb-share", function (event) {
    event.preventDefault();
    var $element = this,
      link = window.location;
    FB.ui(
      {
        method: "share",
        display: "popup",
        description:
          $("#fb-share-text").html() + link + $("#fb-share-hashtags").html(),
        href: window.location.href,
      },
      function (response) {}
    );
  })
  .on("click", ".js-tw-share", function (event) {
    event.preventDefault();
    var link = window.location;
    var _url =
      "https://twitter.com/share?text=" +
      $("#tw-share-text").html() +
      "&hashtags=" +
      $("#tw-share-hashtags").html();
    window.open(
      _url,
      "compartir",
      "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=500"
    );
  })
  .on("click", ".js-animate", function (event) {
    event.preventDefault();
    if ($(".mobile").hasClass("opened")) {
      $(".navbar-toggle").trigger("click");
    }
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );
        return false;
      }
    } else {
      window.location = $(this).attr("href");
    }
  })
  .on("click", ".js-btn-concert", function (event) {
    event.preventDefault();
    var $element = $(this);
    option = $element.data("concert");
    $('.concerts-select option[value="' + option + '"]')
      .prop("selected", true)
      .trigger("formikation.update");
    $("html, body").animate(
      {
        scrollTop: $(".wrapper__form").offset().top,
      },
      1000
    );
  })
  .on("click", ".gtm-link", function (event) {
    event.preventDefault();
    var trackOutboundLink = function (url, isHidden, dataEvent) {
      document.location = url;
    };
    var $element = jQuery(this),
      $url = !$element.attr("href")
        ? window.atob($element.data("id"))
        : $element.attr("href"),
      //   $url = $(location).attr('href');
      isHidden =
        $element.hasClass("hddn-links") || $element.attr("href") == "#"
          ? true
          : false,
      dataEvent = !$element.data("event") ? "" : $element.data("event");
    trackOutboundLink($url, isHidden, dataEvent);
  })
  .on("click", ".gtm-link-pharma", function (event) {
    event.preventDefault();
    var $element = jQuery(this),
      $url = !$element.attr("href")
        ? window.atob($element.data("id"))
        : $element.attr("href"),
      isHidden =
        $element.hasClass("hddn-links") || $element.attr("href") == "#"
          ? true
          : false,
      dataCategory = !$element.data("gtm-category")
        ? ""
        : $element.data("gtm-category"),
      dataID;
    if (
      ($element.hasClass("hddn-links") || $element.attr("href") == "#") &&
      !$element.attr("data-event")
    ) {
      dataID = window.atob($element.data("id"));
    } else if ($element.data("event").length > 0) {
      dataID = $element.data("event");
    } else {
      dataID = "";
    }
    trackOutboundLink($url, isHidden, dataCategory, dataID);
  })
  .on("click", ".js-selector", function (event) {
    event.preventDefault();
    var $element = jQuery(this),
      $target = jQuery(".selector__pharma"),
      $ul = $target.find("ul");

    $target.toggleClass("active");
    $ul.slideToggle();
  })
  .on("click", ".js-btn-concert", function (event) {
    event.preventDefault();
    var $element = $(this);
    option = $element.data("concert");
    $('.concerts-select option[value="' + option + '"]')
      .prop("selected", true)
      .trigger("formikation.update");
    $("html, body").animate(
      {
        scrollTop: $(".wrapper__form").offset().top,
      },
      1000
    );
  })
  .on("click", ".hddn-links", function (event) {
    event.preventDefault();
    var $element = jQuery(this),
      $url = window.atob($element.data("id"));

    window.open($url);
  })
  .on("keyup", ".js-number", function (event) {
    event.preventDefault();
    var $element = $(this),
      value = $(this).val(),
      lengthMax = $(this).attr("size"),
      minDate = $(this).attr("min"),
      maxDate = $(this).attr("max");

    if (lengthMax > value.length) {
      $element.val(value.replace(/[^0-9,\.]/g, ""));
    } else if (lengthMax == value.length) {
      $element.val(value.replace(/[^0-9,\.]/g, ""));
      if (minDate !== "undefined" && parseInt($element.val()) < minDate) {
        $element.val(minDate);
      }
      if (maxDate !== "undefined" && parseInt($element.val()) > maxDate) {
        $element.val(maxDate);
      }
    } else {
      var lastValue = $element.val();
      $element.val(lastValue.substring(0, lengthMax));
    }
  })
  .on("click", "a.language-link", function (event) {
    //Sets cookie after clicking on language selector link
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var $element = $(this),
      langcode = $(this).attr("data-langcode"),
      $url = window.location.href,
      isHidden = true,
      dataCategory = $element.data("gtm-category"),
      dataID = $element.data("event");

    $.cookie("multilink_pl", langcode, {
      path: "/",
      domain: COOKIE_DOMAIN,
    });

    // only call trackOutboundLink if defined
    if (typeof trackOutboundLink === "function")
      trackOutboundLink($url, isHidden, dataCategory, dataID);

    window.location = $element.attr("href");
  })
  .on("click", ".open-modal", function (event) {
    event.preventDefault();
    var $element = $(this);
    target = $element.attr("href");
    $(target).modal("show");
  });

/*Scroll events on microsites*/
$("#bexident-cine2019-banner").click(function () {
  $("html, body").animate({
    scrollTop: $("#bexident-cine2019").offset().top - 59,
  });
});

$("#sorteowoman2019").click(function () {
  $("html, body").animate({
    scrollTop: $("#sorteo-mes-de-la-mujer2019").offset().top - 59,
  });
});

$("#ya-tengo-codigo").click(function () {
  $("html, body").animate({
    scrollTop: $("#nutraisdin-culitos-felices").offset().top - 130,
  });
});

$("#no-tengo-codigo").click(function () {
  $("html, body").animate({
    scrollTop: $("#obsequio-por-la-compra").offset().top - 175,
  });
});

$("#scroll-down-origin").click(function () {
  $("html, body").animate({
    scrollTop: $("#scroll-down-objective").offset().top - 59,
  });
});

$("#scroll-down-origin-two").click(function () {
  $("html, body").animate({
    scrollTop: $("#scroll-down-objective-two").offset().top - 59,
  });
});

$("#scroll-down-origin-three").click(function () {
  $("html, body").animate({
    scrollTop: $("#scroll-down-objective-three").offset().top - 59,
  });
});

$("#scroll-down-origin-four").click(function () {
  $("html, body").animate({
    scrollTop: $("#scroll-down-objective-four").offset().top - 59,
  });
});

$("#scroll-down-origin-five").click(function () {
  $("html, body").animate({
    scrollTop: $("#scroll-down-objective-five").offset().top - 59,
  });
});

$("#scroll-down-origin-six").click(function () {
  $("html, body").animate({
    scrollTop: $("#scroll-down-objective-six").offset().top - 59,
  });
});

$(document).ready(function () {
  var $modal = $("#modal-normal");
  var $result = $("#modal-result");
  var $btn = $(".modal-btn");
  var $close = $(".modal-close");

  if (
    window.location.href !==
      "https://www-preview.isdin.com/isdinceutics/rutina-noche/#lead-block" ||
    window.location.href !==
      "https://www.isdin.com/isdinceutics/rutina-noche/#lead-block"
  ) {
    $modal.addClass("appear");
  }
  if (
    window.location.href ===
      "https://www-preview.isdin.com/isdinceutics/rutina-noche/#lead-block" ||
    window.location.href ===
      "https://www.isdin.com/isdinceutics/rutina-noche/#lead-block"
  ) {
    $modal.hide();
    $(".legal-info").hide();
    $(".forms-block-title").hide();
    $(".forms-block-subtitle").hide();
    var found = false;

    $result.addClass("appear").css("display", "flex");
    setInterval(function () {
      var promoData = $("#result-promo-data").html();
      // if ( typeof ($('#result-promo-data').html()) !== 'undefined' && !found ) {
      //     found = true;
      //     $result.addClass("appear").css('display', 'flex');
      // }
      $("#modal-result .modal-isdinceutics-content").html(promoData);
    }, 1000);
  }

  $btn.click(function () {
    $("html, body").animate({
      scrollTop: $(".forms-block").offset().top - 145,
    });
    $(this)
      .closest(".modal-overlay")
      .removeClass("appear")
      .addClass("disappear");
  });

  $close.click(function () {
    $(this)
      .closest(".modal-overlay")
      .removeClass("appear")
      .addClass("disappear")
      .css("display", "none");
    window.location.hash = "";
  });
});

/*Fin de eventos */

/** Cargas solo en mobile **/
$(document)
  .on("enter.mobile.mqbe", function () {
    $(document)
      // .on("touchstart",".pharmacy-online .title", function(event){
      //   event.preventDefault();
      //   var $element = $(this),
      //       $target = $element.closest('.pharmacy-online');
      //
      //   $target.find('.js-toggle-product').slideToggle();
      //   $target.toggleClass('active');
      //
      // })
      // .on("touchstart",".wrapper__pharmacy__online p.title_pharmacy", function(event){
      //   event.preventDefault();
      //   var $element = $(this),
      //       $target = $('.map-content-pharma.js-toggle-info');
      //
      //     if($element.hasClass('active')){
      //       $target.animate({
      //         height:0
      //       }, 1000);
      //     }else{
      //       window.location = $(this).attr('href');
      //     }
      //   })
      .on("click", ".submenu-level-3 .navbar-toggle", function (event) {
        event.preventDefault();
        var $element = $(this),
          target = $element.data("menu");

        $element.toggleClass("collapsed");
        $(target).toggle();
      });

    //   $(document)
    //   .on('enter.mobile.mqbe', function() {
    $(document).on(
      "click touchstart",
      ".pharmacy-online .title",
      function (event) {
        event.preventDefault();
        var $element = $(this),
          $target = $element.closest(".pharmacy-online");
        $target.find(".js-toggle-product").slideToggle();
        $target.toggleClass("active");
      }
    );
    $(document).on(
      "click touchstart",
      ".wrapper__pharmacy__online p.title_pharmacy",
      function (event) {
        // event.preventDefault();
        var $element = $(this),
          $target = $(".map-content-pharma.js-toggle-info");

        if ($element.hasClass("active")) {
          $target.animate(
            {
              height: 0,
            },
            1000
          );
        } else {
          $target.animate(
            {
              height: 600,
            },
            1000
          );
        }
        $(".title_pharmacy.js-toggle-product").toggleClass("active");
      }
    );
  })
  .on("enter.tablet.mqbe", function () {
    $(document)
      .on("click", ".pharmacy-online .title", function (event) {
        event.preventDefault();
        var $element = $(this),
          $target = $element.closest(".pharmacy-online");

        $target.find(".js-toggle-product").slideToggle();
        $target.toggleClass("active");
      })
      .on(
        "click",
        ".wrapper__pharmacy__online p.title_pharmacy",
        function (event) {
          event.preventDefault();
          var $element = $(this),
            $target = $(".map-content-pharma.js-toggle-info");

          if ($element.hasClass("active")) {
            $target.animate(
              {
                height: 0,
              },
              1000
            );
          } else {
            $target.animate(
              {
                height: 600,
              },
              1000
            );
          }
          $(".title_pharmacy.js-toggle-product").toggleClass("active");
        }
      );
    // });
  });

// $("#to-loveIsdin").on("click", function () {
//     var filiate = $('html').attr('urlfiliate');
//     var homeUrl = '/' + ((filiate !== '') ? filiate + '/' : '');
//     var url = 'https://www.love.isdin.com/med' + homeUrl
//     // window.location = url
//     window.open(url, '_blank');
// });

$(document).on("click touchstart", ".btn.btn-default.noAccept", function () {
  var filiate = $("html").attr("urlfiliate");
  var homeUrl = "/" + (filiate !== "" ? filiate + "/" : "");
  window.location.href = "https://www.isdin.com" + homeUrl;
});

$(document).on("click touchstart", ".to-loveIsdin", function () {
  var filiate = $("html").attr("urlfiliate");
  var homeUrl = "/" + (filiate !== "" ? filiate + "/" : "");
  // if homeUrl == '/es-CL/' url is https://www.isdin.com/es-CL/love-isdin/
  var url;
  if (homeUrl == "/es-CL/") {
    url = "https://www.isdin.com/es-CL/love-isdin/";
  } else if (homeUrl == "/es-CO/") {
    url = "https://www.isdin.com/es-CO/love-isdin/";
  } else if (homeUrl == "/es-AR/") {
    url = "https://www.isdin.com/es-AR/love-isdin/";
  } else {
    url = "https://www.love.isdin.com/med" + homeUrl;
  }
  window.open(url, "_blank");
});

// on click .link-amazon-gb send 2 GA events
// Categoria: header
// Action: click-buy-button
// ----
// Categoria: header
// Action: click-etailer
// Label: amazon
$(document).on("click", ".link-amazon-gb", function () {
  dataLayer.push({
    event: "eventga",
    eventCategory: "header",
    eventAction: "click-buy-button",
  });
  dataLayer.push({
    event: "eventga",
    eventCategory: "header",
    eventAction: "click-etailer",
    eventLabel: "amazon",
  });
});
